export default __webpack_public_path__ + "static/media/package1.0d3c839a.jpg";